import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import * as $ from 'jquery';
import { Moment } from 'moment';
require('fullcalendar');
require('fullcalendar/dist/fullcalendar.css');
import { namespace } from 'vuex-class';
import {
  AGENDA_MODULE_NAMESPACE,
  AGENDA_GET_APPOINTMENTS,
  AGENDA_SET_APPOINTMENT_BY_ID
}
  // @ts-ignore
  from '@/store/agenda/agenda-types.store';
import {
  IAppointmentParameter, IAppointment, AppointmentDto, IAppointmentQuickUpdate, AppointmentListingViewModel
} from '../../../../models/appointment';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import '../../../../utils/CalendarConfigs.util';
import { VIEW_WEEK } from '../../../../common/constants';
import { AGENDA_DELETE, AGENDA_MODIFY, AGENDA_GET_APPOINTMENT_BY_ID, AGENDA_SET_PARTIAL_PARAMETER } from '../../../../store/agenda/agenda-types.store';

const AgendaStore = namespace(AGENDA_MODULE_NAMESPACE)
const calendarId: string = '#calendar';
@Component
class AgendaCalendar extends Vue {
  @AgendaStore.Getter appointmentParameter: IAppointmentParameter;

  dtStartDate: Moment;
  isLoading: boolean
  /**
     *
     */
  constructor() {
    super();
    this.dtCalendarView = VIEW_WEEK;
    this.isLoading = true
  }

  @Prop({ default: null, type: [Object] })
  value: any;
  @Prop({ default: null, type: [String] })
  currentDate: string;
  @Prop({ default: null, type: [Object] })
  startDate: Moment;

  dtSearchParam: IAppointmentParameter;
  dtCalendarView: string;

  @AgendaStore.Action(AGENDA_GET_APPOINTMENTS)
  storeGetAppointments: () => Promise<IAppointment>;

  @AgendaStore.Action(AGENDA_DELETE)
  storeRemoveAppointment: (payload: { originId: string, ticketId: string }) => Promise<any>;

  @AgendaStore.Action(AGENDA_MODIFY)
  storeQuickUpdateAppointment: (payload: IAppointmentQuickUpdate) => Promise<any>;

  @AgendaStore.Mutation(AGENDA_SET_PARTIAL_PARAMETER)
  storeSetParameter: (param: IAppointmentParameter) => void;

  @AgendaStore.Mutation(AGENDA_SET_APPOINTMENT_BY_ID)
  storeSetAppointmentById: (payload: { id?: number, appointment: IAppointment }) => Promise<IAppointment>;
  @AgendaStore.Action(AGENDA_GET_APPOINTMENT_BY_ID)
  storeGetAppointmentById: (id?: number) => Promise<IAppointment>;

  get AgendaElement(): any { return this.value; }
  set AgendaElement(value: any) { this.$emit('input', value); }

  get coAgendaCurrentDate(): string { return this.currentDate; }
  set coAgendaCurrentDate(value: string) { this.$emit('update:currentDate', value); }
  get coAgendaStartDate() { return this.startDate }
  set coAgendaStartDate(value: Moment) { this.$emit('update:startDate', value); }

  handleEventClick(calEvent, jsEvent, view) {
    this.$emit('eventClick', { calEvent, jsEvent, view })
  }

  handleSelect(start: Moment, end: Moment, jsEvent, view) {

    const appointment: IAppointment = new AppointmentDto({
      start_date: start.format(),
      end_date: end.format()
    })

    if (this.appointmentParameter.type) {
      appointment.type = this.appointmentParameter.type;
    }



    this.storeSetAppointmentById({ appointment: appointment })
    this.$emit('select', appointment)
  }
  /** Update locale at runtime */
  _clearTimeout: any;
  @Watch('$i18n.locale')
  handleUpdateAgendaLocale(locale: string) {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {
      this.AgendaElement.fullCalendar('option', 'locale', locale);
      this.coAgendaCurrentDate = this.dtStartDate.locale(locale).format('MMMM YYYY');
      this.coAgendaStartDate = this.dtStartDate.locale(locale);
    }, 100);

  }

  async handleFetchEvents(start: Moment, end: Moment, timezone, callback) {
    this.dtStartDate = start;
    this.coAgendaCurrentDate = start.format('MMMM YYYY');
    this.coAgendaStartDate = start;

    this.storeSetParameter({
      firstday: DateTimeHelper.parseISODate(start),
      lastday: DateTimeHelper.parseISODate(end)
    })

    this.isLoading = true

    return this.storeGetAppointments()
      .then((appointments: any) => {
        this.isLoading = false
        return callback(appointments)
      })
      .catch((error) => console.log(error))
  }

  renderColumnHeader(mon: Moment) {
    if (($(calendarId) as any).fullCalendar('getView').name !== 'month')
      return '<i class="fc-day-header-cus fc-day-header-weekday">' + mon.format("dddd") + '</i></br><i class="title fc-day-header-cus fc-day-header-cus--bigger">' + mon.format('DD') + '</i>';
    else
      return '<i class="fc-day-header-cus fc-day-header-weekday">' + mon.format("dddd") + '</i>';
  }
  handleRenderEventElement(event, element) {
    try {
      const AgendaEventItem = require('../agenda-event-item/AgendaEventItem.vue').default;
      const self = this;
      return new AgendaEventItem({
        i18n: self.$i18n,
        router: self.$router,
        data: () => ({
          event: event,
          canRemove: this.getCanRemove(event),
          canUpdate: this.getCanUpdate(event),
          allowResizable: this.dtCalendarView === VIEW_WEEK
        }),
        methods: {
          handleDelete: (event) => self.handleDelete(event),
          handleConvert: (event) => self.handleConvert(event),
          handleUpdate: (event) => self.handleUpdate(event)
        }
      }).$mount().$el;
    } catch (error) {
      console.log(error)
    }
  }

  getCanRemove(event: { type: string, appointment_state: string }) {
    //if (event.appointment_state === 'finished' && event.type === AppointmentTypes.Appointment) return {}
    return {
      event: this.$route.meta.remove_event,
      appointment: this.$route.meta.remove_appointment
    }
  }
  getCanUpdate(event: { type: string, appointment_state: string }) {
    //if (event.appointment_state === 'finished' && event.type === AppointmentTypes.Appointment) return {}
    return {
      event: this.$route.meta.update_event,
      appointment: this.$route.meta.update_appointment
    }
  }
  handleDelete(event: AppointmentListingViewModel) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeRemoveAppointment({ originId: event.originId, ticketId: event.ticketId })
        .then(response => {
          setTimeout(() => {
            $('.menuable__content__active').remove();
          }, 200);
          this.AgendaElement.fullCalendar('removeEvents', [event['_id']]);
        })
        .catch(error => console.log(error))
    }, 300);
  }
  handleConvert(event: AppointmentListingViewModel) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeQuickUpdateAppointment({ id: event.originId, appointment_state: 'confirmed' })
        .then(response => {
          setTimeout(() => {
            $('.menuable__content__active').remove();
          }, 200);

          this.AgendaElement.fullCalendar('removeEvents', [event['_id']]);
          this.AgendaElement.fullCalendar('renderEvent', new AppointmentListingViewModel(response));
        })
        .catch(error => console.log(error))
    }, 300);
  }
  handleUpdate(event: any) {
    this.storeGetAppointmentById(event.originId)
      .then(appointment => {
        this.$emit('select', { ...appointment, event: event })
      })
      .catch(error => console.log(error))
  }

  handleResize(event, delta, revertFunc, jsEvent, ui, view) {
    /*if (event.appointment_state === AppointmentState.Finished) {
      revertFunc();
      return;
    }*/
    this.storeQuickUpdateAppointment({
      id: event.originId,
      start_date: event.start.format(),
      end_date: event.end.format()
    })
      .catch(error => {
        console.log(error)
        revertFunc();
      })
  }
  handleDrop(event, delta, revertFunc, jsEvent, ui, view) {
    /*if (event.appointment_state === AppointmentState.Finished) {
      revertFunc();
      return;
    }*/
    this.storeQuickUpdateAppointment({
      id: event.originId,
      start_date: event.start.format(),
      end_date: event.end.format()
    })
      .catch(error => {
        revertFunc();
      })
  }
  handleViewDestroy(view, element) {
    $('.calendar-menu-popover').remove(); /** Clear popover's DOM when change view or change page */
  }

  get canCreate(): boolean {
    const { add_appointment, create_draft_appointment, create_event } = this.$route.meta;
    return add_appointment || create_draft_appointment || create_event
  }
  get canUpdate(): boolean {
    const { update_appointment, update_event } = this.$route.meta;
    return update_appointment || update_event
  }


  mounted() {
    /** Change current locale of calendar on runtime */
    const options: { [key: string]: any } = {
      defaultView: 'agendaWeek',
      slotLabelFormat: 'HH',
      firstDay: 1,
      locale: this.$i18n.locale,
      editable: this.canUpdate,
      eventLimit: true,
      selectable: this.canCreate,
      lazyFetching: true,
      eventOverlap: true,
      events: (start, end, timezone, callback) => this.handleFetchEvents(start, end, timezone, callback),
      eventClick: (calEvent, jsEvent, view) => this.handleEventClick(calEvent, jsEvent, view),
      eventRender: (event, element) => this.handleRenderEventElement(event, element),
      columnHeaderHtml: (moment) => this.renderColumnHeader(moment),
      select: (start, end, jsEvent, view) => this.handleSelect(start, end, jsEvent, view),
      eventResize: (event, delta, revertFunc, jsEvent, ui, view) => this.handleResize(event, delta, revertFunc, jsEvent, ui, view),
      eventDrop: (event, delta, revertFunc, jsEvent, ui, view) => this.handleDrop(event, delta, revertFunc, jsEvent, ui, view),
      viewDestroy: this.handleViewDestroy
    }

    const { event_id, start_date } = this.$route.query;
    if (event_id && start_date) {
      options.defaultDate = start_date
    }

    this.$watch("$route.query", ({ event_id, start_date }) => {
      if (event_id && start_date) {
        this.AgendaElement.fullCalendar('gotoDate', start_date)
      }
    })

    /** Init calendar | Config */
    this.AgendaElement = ($(calendarId) as any).fullCalendar(options);

    this.$nextTick(() => {
      $('.fc-toolbar').addClass('hidden');
    })
  }
}

export default AgendaCalendar;



// WEBPACK FOOTER //
// ./src/containers/agenda/components/agenda-calendar/index.ts